import type { ExecutionSummary, MatrixCell, Outcome } from "@/api/types";

export type CellOutcome = Outcome | "EXCLUDED";

type CellLike = Pick<MatrixCell, "executions" | "current_execution_id" | "disposition">;

export function currentExecution(cell: Pick<MatrixCell, "executions" | "current_execution_id">): ExecutionSummary | undefined {
  return cell.executions.find((e) => e.execution_id === cell.current_execution_id) ?? cell.executions.at(-1);
}

export function cellOutcome(cell: CellLike): CellOutcome {
  const e = currentExecution(cell);
  if (e) return e.outcome;
  return cell.disposition === "EXCLUDED" ? "EXCLUDED" : "UNKNOWN";
}

export function runProgress(run: { cells: CellLike[] }): { done: number; total: number } {
  const runnable = run.cells.filter((c) => c.disposition !== "EXCLUDED");
  return { done: runnable.filter((c) => currentExecution(c)?.lifecycle === "COMPLETED").length, total: runnable.length };
}
